import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ExamPreferenceModal from './ExamPreferenceModal';

export const getExamLandingPath = (examType) => {
  if (examType === 'ielts') return '/ielts-dashboard';
  if (examType === 'pte') return '/pte-dashboard';
  return '/choose-exam';
};

export const PteDashboardEntry = ({ children }) => {
  const landingPath = getExamLandingPath(localStorage.getItem('exam-type'));
  if (landingPath !== '/pte-dashboard') return <Navigate replace to={landingPath} />;
  return children;
};

const ExamPreferenceGate = () => {
  const navigate = useNavigate();

  const handleSelectExam = (examType) => {
    localStorage.setItem('exam-type', examType);
    window.dispatchEvent(new CustomEvent('examTypeChanged', { detail: { examType } }));
    navigate(getExamLandingPath(examType), { replace: true });
  };

  return <ExamPreferenceModal open onSelect={handleSelectExam} />;
};

export default ExamPreferenceGate;
